
// FancyDressActivity
import React from 'react';

import FieldTrip92025 from '../views/FieldTrip92025/FieldTrip92025';

const FancyDressActivityPage = () => {
  return <FieldTrip92025/>;
};

export default FancyDressActivityPage;